import { headerAuthorization } from '../../../shared/helpers/localstorage-helper';
import { SelectOption } from '../../../shared/types/select-options';
import { BASE_URL } from '../../../shared/consts/variables';

export const getLanguages = async () => {
    try {
        const languages = await fetch(`${BASE_URL}/languages`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...headerAuthorization(),
            },
        });
        return languages;
    } catch (error) {
        console.error('❌ Erro ao buscar dados do usuário:', error);
    }
};

export const getLanguagesSelect = async (): Promise<SelectOption[]> => {
    try {
        const response = await fetch(`${BASE_URL}/languages`,{
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...headerAuthorization(),
            },
        });
        const languages = await response.json();
        
        const mapped = languages.map(({ id, name }: any) => ({
            id,
            label: name,
        }));
        
        return mapped;
    } catch (error) {
        console.error('❌ Erro ao buscar languages:', error);
        return [];
    }
};